/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Destination_DomesticInputs */

const en_reference_destination_domestic = /** @type {(inputs: Reference_Destination_DomesticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domestic`)
};

/**
* | output |
* | --- |
* | "Domestic" |
*
* @param {Reference_Destination_DomesticInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_destination_domestic = /** @type {((inputs?: Reference_Destination_DomesticInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Destination_DomesticInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_destination_domestic(inputs)
});